/**
 * Tutorial guidato degli Imballaggi.
 *
 * Il menu a tre puntini si racconta illuminando il bottone e non le voci dentro:
 * un menu di Vuetify aperto dal tutorial si richiude da solo, perche' il click
 * programmatico e quello su "Avanti" arrivano a `document` a un soffio di distanza.
 */
const SCOPE = '[data-tour-scope="setting-packaging"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createPackagingTourSteps() {
	return [
		{
			body: "Gli imballaggi sono le scatole con cui spedisci, con le loro misure. Servono al gestionale per dire al corriere quanto e' grande il pacco - e visto che i corrieri fatturano a peso volumetrico, una scatola dichiarata male costa soldi veri a ogni spedizione.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Gli imballaggi',
		},
		{
			body: "Il + apre la pagina per aggiungerne uno: nome e misure della scatola in centimetri. Annulla, o la freccia in alto, riporta qui. Conviene censire le scatole che si usano davvero, non tutte quelle del magazzino.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un imballaggio',
		},
		{
			body: "Scrivi almeno tre lettere del nome e premi Invio. La ricerca, la pagina e l'ordinamento restano nell'indirizzo: ricaricando, o tornando da una scheda, la lista riparte da li'.",
			key: 'search',
			placement: 'bottom',
			target: at('search'),
			title: 'Cercare un imballaggio',
		},
		{
			body: "La tabella mostra lo stato, il nome e le misure nell'ordine lunghezza × larghezza × altezza. Vale la pena misurare la scatola una volta e scriverlo giusto.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "I tre puntini a inizio riga aprono Modifica, la pagina per correggere nome e misure, ed Elimina, che chiede conferma prima di cancellare.",
			key: 'row-menu',
			missing: 'skip',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
		{
			body: "L'interruttore accende e spegne l'imballaggio, e salva subito. Spento sparisce dalle scelte in fase di spedizione, ma resta scritto sulle spedizioni gia' fatte.",
			key: 'switch',
			missing: 'skip',
			placement: 'right',
			target: at('switch'),
			timeout: 250,
			title: 'Accendere un imballaggio',
		},
	];
}
